export enum DIALOG_IDS {
  DOWNLOAD_MODEL = 'download-model',
  LOGIN = 'login',
  UPDATE_PASSWORD = 'update-password',
  RESET_PASSWORD = 'reset-password',
  VERIFY_EMAIL = 'verify-email',
  SIGNUP = 'signup'
}
